import React, {useRef} from "react";
import { questionTypeMapping , ReverseQtypeMapping } from "../../utils/common";
import async from "../../utils/service.js";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import EditQuestion from "./EditQuestion";
import moment from "moment";
// import { type } from "os";
import { Toast } from "primereact/toast";

function EditPoll(props) {
  const myToast = useRef(null);

  const showWarningToast = (header, content) => {
    myToast.current.show({severity : "warn", summary : header, detail : content, life : 10000})
  }


  const startCalender = useRef(null);
  const endCalender = useRef(null);

  const [showEditDialog, setEditDialog] = React.useState(false);
  const [showAddDialog, setAddDialog] = React.useState(false);
  // const [refresh, setRefresh] = React.useState(false)
  // const [addDialog, setAddDialog] = React.useState(false);
  const [deleteDialog, setDeleteDialog] = React.useState(false);
  const [dateChangeDialog, setdateChangeDialog] = React.useState(false);

  const [dates, setDates] = React.useState({
    surveyStartDate : props.pollList.surveyStartDate,
    surveyEndDate : props.pollList.surveyEndDate
   })

  const [delqid, setDelqid] = React.useState(0)
  const [delopIds, setdelOpids] = React.useState([])

  const [chanRegmapping, setCRMapping] = React.useState({});

  const [ques, setQues] = React.useState({});
  const [poll, setPoll] = React.useState(props.pollList);
  const initialQuestion = {
    questionType: "Radio Type",
    questionText: "",
    options: [{ optionText: "", minRange :null, maxRange : null }, { optionText: "", minRange : null, maxRange : null }],
    channels: [],
    regions: [],
  };

  const createJSON = (question) => {
    var AddSurveyJSON = {}
    var start_date = poll.surveyStartDate
    var end_date = poll.surveyEndDate


    // AddSurveyJSON.surveyStartDate = start_date.getFullYear() + "-" + start_date.getMonth() + "-"
    // AddSurveyJSON.surveyEndDate = end_date.getFullYear() + "-" + end_date.getMonth() + "-"
    // if (start_date.getDate() < 10){
    //   AddSurveyJSON.surveyStartDate+="0"
    // }
    // if (end_date.getDate() < 10){
    //   AddSurveyJSON.surveyEndDate+="0"
    // }
    // AddSurveyJSON.surveyStartDate+=start_date.getDate()
    // AddSurveyJSON.surveyEndDate+=end_date.getDate()
    AddSurveyJSON.surveyId = poll.surveyId
    AddSurveyJSON.surveyStartDate = start_date
    AddSurveyJSON.surveyEndDate = end_date
    AddSurveyJSON.surveyType = "Type"
    AddSurveyJSON.surveyDescription = "SurveyDescription"

    const questionList = [question]
    var chanques = []
    const quesChannels = question.channels;
    const quesRegions = question.regions;
    for (var chid=0; chid<quesChannels.length;chid++){
      for (var regid=0; regid<quesRegions.length ;regid++){
        if (chanRegmapping[quesChannels[chid]].includes(quesRegions[regid])){
          chanques.push({channelId : quesChannels[chid], regionId : quesRegions[regid]})
        }
      } 
    }

    questionList[0]["channelQuestions"] = chanques
    delete questionList[0]["channels"]
    delete questionList[0]["regions"]

    questionList[0]["questionType"] = questionTypeMapping[questionList[0].questionType]
    if (questionList[0].questionType === "SLIDER"){
      for (var opid=0;opid < questionList[0].options.length; opid++){
        if(questionList[0].options[opid].minRange === null && questionList[0].options[opid].maxRange === null){
          questionList[0]["options"].splice(opid, 1)
        }
      }
    }
    AddSurveyJSON.questions = questionList

    return AddSurveyJSON
  }

  const handleEditorAdd = (question) => { 
    if (question.channels.length === 0){ showWarningToast("", "Please select a Channel")}
    else if (question.regions.length === 0){ showWarningToast("", "Please select a Region")}
    else {
      const EditJSON = createJSON(question)
      for (var i in delopIds){
        async.deleteOption(delopIds[i])
        .then(resp => {})
      }
      async.saveorUpdateSurvey(EditJSON).then(resp => {
        setEditDialog(false)
        setAddDialog(false)
        setdelOpids([])
        props.refresh(true)
      })
    }
  }

  const handleDelete = () => {
    async.deletequestion(delqid).then(resp => {
      setDeleteDialog(false)
      props.refresh(true)
    })
  }

  const handleDateChange = () => {
    var send_data = dates
    send_data["surveyId"] = poll.surveyId
    send_data["surveyStartDate"] = moment(dates.surveyStartDate).format("YYYY-MM-DD")
    send_data["surveyEndDate"] = moment(dates.surveyEndDate).format("YYYY-MM-DD")

    async.UpdateSurveyDate(send_data)
    .then(resp => {
      if (resp.data === "Success"){
        
        var node;
        if (poll.surveyStartDate !== dates.surveyStartDate){
          node = startCalender.current
          node.inputElement.value = moment(dates.surveyStartDate).format("DD/MM/YYYY")
        }
        else{
          node = endCalender.current
          node.inputElement.value = moment(dates.surveyEndDate).format("DD/MM/YYYY")
        }

        props.refresh(true)
        setPoll((prev_poll) => ({...prev_poll, surveyStartDate : dates.surveyStartDate, surveyEndDate : dates.surveyEndDate}))
      }
      else {
        showWarningToast("Request failed", "Survey is coinciding with other surveys")
      }
    })

    // setPoll({...poll, surveyStartDate : dates.surveyStartDate, surveyEndDate : dates.surveyEndDate})
    setdateChangeDialog(false)
    // setRefresh(true)
  }

  const handleDiscardDateChange = () => {
    setDates({surveyStartDate : poll.surveyStartDate, surveyEndDate :poll.surveyEndDate})
    setdateChangeDialog(false)
  }

  const editQuestion = (e, question) => {
    setEditDialog(true);

    var chanregData = question.channelQuestions
    var channels = []
    var regions = []
    for (var i=0;i<chanregData.length;i++){
      if (!channels.includes(chanregData[i].channelId)){
        channels.push(chanregData[i].channelId)
      }
      if (!regions.includes(chanregData[i].regionId)){
        regions.push(chanregData[i].regionId)
      }
    }

    question.questionType = ReverseQtypeMapping[question.questionType]
    question.channels = channels
    question.regions = regions

    setQues(question);
  };

  const addQuestion = () => {
    setAddDialog(true);
    setQues(initialQuestion);
  };

  const deletequestion = (id) => {
    setDelqid(id)
    setDeleteDialog(true)
  }

  const addDatenum = (date, num) => {
    var temp_date = new Date(date)
    temp_date.setDate(temp_date.getDate() + num) 
    return temp_date
  }

  // const maxStartDate = () => {
  //   const endDate = new Date(poll.surveyEndDate)
  //   endDate.setDate(endDate.getDate() - 1)
  //   return endDate
  // }

  // const minEndDate = () => {
  //   const startDate = new Date(poll.surveyStartDate)
  //   startDate.setDate(startDate.getDate() + 1)
  //   return startDate
  // }

  const startDateChange = (event) => {
    setPoll((prevPoll) => ({...prevPoll, surveyStartDate : prevPoll.surveyStartDate}))
    setDates((prev_dates) => ({...prev_dates, surveyStartDate : event.value}))
    setdateChangeDialog(true)
  }

  const endDateChange = (event) => {
    setPoll((prevPoll) => ({...prevPoll, surveyEndDate : prevPoll.surveyEndDate}))
    setDates((prev_dates) => ({...prev_dates, surveyEndDate : event.value}))
    setdateChangeDialog(true)
  }

  // const RenderEditFooter = () => {
  //   return (
  //     <div className="spacing1">
  //       <Button
  //         label="Discard"
  //         onClick={() => setEditDialog(false)}
  //         className="p-button  p-button-sm btn3"
  //       />
  //       <Button
  //         label="Save"
  //         onClick={editQuestion}
  //         autoFocus
  //         className="p-button p-button-sm btn3"
  //       />
  //     </div>
  //   );
  // };

  const RendeBottomFooter = () => {
    return (
      <div className="spacing1">
        <Button
          label="Close"
          onClick={() => deleteDialog ? setDeleteDialog(false) : handleDiscardDateChange()}
          className="p-button p-button-sm btn3"
        />
        <Button
          label="Confirm"
          onClick={() => deleteDialog ? handleDelete() : handleDateChange()}
          autoFocus
          className="p-button p-button-sm btn3"
        />
      </div>
    );
  };

  React.useEffect(() => {
    async.getRegionCountry().then((response) => {
      var chanData = response.data.availableChannels
      var temp_mapping = {}
      for (var i=0;i<chanData.length;i++){
        temp_mapping[chanData[i].channelId] = chanData[i].regions.map(item => item.regionId)
      }
      setCRMapping(temp_mapping)
    });
    // setRefresh(false)
  }, [])
  return (
    <div style={{marginTop: "2rem" }}>
        <Toast ref={myToast} baseZIndex={20000}/> 
        {/* <div style={{ marginBottom: "2rem" }}>
          <BreadCrumb model={items} home={home} />
        </div> */}
        <Button
          label="Add Question"
          onClick={addQuestion}
          className="p-button p-button-sm btn3"
          type="button"
        />
        <div className="p-fluid formgrid grid mt-3">
          <div className="field col md:col-3 sm:col-12">
            <label htmlFor="firstname" className="label">
              * Start Date
            </label>
            <Calendar
              ref = { startCalender} 
              dateFormat="MM d, yy"
              name="startDate"
              viewDate={new Date(poll.surveyStartDate)}
              onViewDateChange = {(e) => {}}
              onViewChange = {(e) => {}}
              value={new Date(poll.surveyStartDate)}
              // onChange={(e) => setPoll({ ...poll, surveyStartDate: e.value })}
              onChange={(e) => startDateChange(e)}
              minDate = {addDatenum(new Date(), 1)}
              maxDate={addDatenum(poll.surveyEndDate, -1)}
              showIcon
              required
              showOtherMonths={false}
            />
          </div>
          <div className="field col md:col-3 sm:col-12">
            <label htmlFor="firstname" className="label">
              * End Date
            </label>
            <Calendar 
              ref = {endCalender}
              dateFormat="MM d, yy"         
              name="endDate"
              value={new Date(poll.surveyEndDate)}
              // viewDate={new Date("2020-11-01")}
              // onChange={(e) => setPoll({ ...poll, surveyEndDate: e.value })}
              onChange={(e) => endDateChange(e)}
              minDate={addDatenum(poll.surveyStartDate, 1)}
              showIcon
              required
              showOtherMonths={false}
            />
          </div>
          {/* <div className="field col flex align-items-end mb-4 mr-4 md:col-1 sm:col-12">
          <span
                  // onClick={(e) => editQuestion(e, question)}
                  className="expand"
                >
                  Reset
                </span>
          </div>
          <div className="field col flex align-items-end mb-4 md:col-1 sm:col-12">
          <span
                  // onClick={(e) => editQuestion(e, question)}
                  className="expand"
                >
                  Confirm
                </span>
          </div> */}
        </div>
        {/* <div className="p-fluid formgrid grid mt-3"> */}
        {props.pollList.questions.map((question, index) => (
          <React.Fragment key={index}>
            <div className="col">
              <div className="box">
                Question {index + 1}
                <span
                  onClick={(e) => editQuestion(e, question)}
                  className="expand"
                >
                  Edit
                </span>
                <span className="expand" onClick={() => deletequestion(question.questionId)}>
                  Delete
                </span>
                <h5>{question.questionName}</h5>
                { ReverseQtypeMapping[question.questionType] === "Range Type" ? (
                  <React.Fragment>
                    <p>
                      Min {question.options[0].minRange} - Max{" "}
                      {question.options[0].maxRange}{" "}
                    </p>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {question.options.map((option, optionId) => (
                      <div key={optionId} style={{ marginBottom: "1rem" }}>
                        {ReverseQtypeMapping[question.questionType] === "Checkbox" ? (
                          <Checkbox />
                        ) : (
                          <RadioButton />
                        )}{" "}
                        {option.optionText}
                      </div>
                    ))}
                  </React.Fragment>
                )}
              </div>
            </div>
          </React.Fragment>
        ))}
    
      <Dialog
        baseZIndex={10001}
        header={showEditDialog ?  "Edit Question" : "Add Question"}
        visible={showEditDialog || showAddDialog}
        style={{ width: "50vw" }}
        onHide={() => {
          setEditDialog(false);
          setAddDialog(false);
        }}
        focusOnShow={false}
      >
        <EditQuestion questionData={ques} setEditDialog={showEditDialog ? setEditDialog : setAddDialog} handleSubmit={handleEditorAdd} delopIds = {delopIds} setdelOpids = {setdelOpids} refresh = {props.refresh}/>
        
      </Dialog>

      <Dialog
        baseZIndex={10001}
        header={deleteDialog ? "Delete Confirmation" : "Edit Date Confirmation"}
        visible={deleteDialog || dateChangeDialog}
        style={{ width: "50vw" }}
        onHide={() => {deleteDialog ? setDeleteDialog(false) : setdateChangeDialog(false)}}
        focusOnShow={false}
      >
        {
          deleteDialog 
          ?
            <p className="m-0">Are you sure you want to delete this Question?</p>
          :
            <p className="m-0">Are you sure you want to change the survey period?</p>
        }
        
        <RendeBottomFooter />
      </Dialog>
      {/* <Dialog
        header="Add Question"
        visible={showAddDialog}
        style={{ width: "50vw" }}
        onHide={() => {
          setAddDialog(false);
        }}
      >
        <EditQuestion questionData={ques} setAddDialog={setAddDialog} handleSubmit={handleEditorAdd} delopIds = {delopIds} setdelOpids = {setdelOpids}/>
        <RenderEditFooter />
      </Dialog> */}
    </div>
  );
}

export default EditPoll;
